import React from 'react';
import { ReactComponent as Arrow } from '../../../../picture/arrow.svg'
import RateCard from './rateCard';
import './style/rateGroupCard.css';

export default function RateGroupCard({ group, event, selectedRates, setSelectedRates, disable_plus, className = '' , onSubmit = () => {}, waiting_list_cta = '', soldout_label = ''}) {
    const [showMore, setShowMore] = React.useState(event.settings.categories_expanded);
    const toggleShowMore = React.useCallback(() => setShowMore(showMore => !showMore), []);

    return (
        <>
            <div className={`wz-rate-group-card-container ${className}`} onClick={toggleShowMore}>
                <div className='wz-rate-group-card'>
                    <div>
                        <div className='wz-rate-group-title'>{group.name}</div>
                    </div>
                    <div className='wz-rate-group-right'>
                        {/* TODO add status when its ready */}
                        <div className='wz-rate-group-status'></div>
                        <div className='wz-rate-group-icon-container'>
                            <Arrow className={`wz-rate-group-icon ${showMore ? 'wz-rate-group-icon-down' : 'wz-rate-group-icon-up'}`} />
                        </div>
                    </div>
                </div>
                {/* TODO add status when its ready */}
                <div className='wz-rate-group-status-mobile'></div>
            </div>
            {showMore &&
                <>
                    {group.rates.map(rate => (
                        <RateCard key={rate.id} rate={rate} selectedRates={selectedRates} setSelectedRates={setSelectedRates} event={event} disable_plus={disable_plus} onSubmit={onSubmit} waiting_list_cta={waiting_list_cta} soldout_label={soldout_label} />
                    ))}
                    {group.children.map(gr => (
                        <RateGroupCard key={gr.id} className='wz-subgroup' group={gr} event={event} selectedRates={selectedRates} setSelectedRates={setSelectedRates} disable_plus={disable_plus} onSubmit={onSubmit} waiting_list_cta={waiting_list_cta} soldout_label={soldout_label} />
                    ))}
                </>
            }
        </>
    )
}
